import { render, staticRenderFns } from "./StoreSetup.vue?vue&type=template&id=e7bd4b70&"
import script from "./StoreSetup.vue?vue&type=script&lang=js&"
export * from "./StoreSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports